// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"227":"62afcc79","352":"46cea342","357":"14bff1ef","812":"6fcbe56a","902":"15eeb874"}[chunkId] + ".chunk.css";
};